import { useMutation, useQueryClient } from '@tanstack/react-query';
import { subscriptionService } from '../../../services/subscription';
import { toast } from 'react-toastify';
import { useTranslation } from '@hooks/useTranslation';

export const usePauseSubscription = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (subscriptionId: string) =>
      subscriptionService.pauseSubscription(subscriptionId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['organizationSubscription'] });
      toast.success(tActionMessages.subscriptionPausedSuccessfully);
    },
    onError: (error: any) => {
      toast.error(error?.response?.errors?.[0]?.message || tActionMessages.failedToPauseSubscription);
    },
  });
};
